import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

const ATTRIBUTION_TTL_DAYS = 90;
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
// platform click ids we may capture later (openai's, google's); harmless to grab now
// Every ad platform names its click identifier differently and puts it in a
// different place in its conversion payload. Capture the known set; whichever
// is present (usually one, matching utm_source) gets stored. Adding a channel
// later = add its key here, no other frontend change.
//   oppref  = OpenAI / ChatGPT Ads   gclid  = Google Ads
//   fbclid  = Meta                    rdt_cid = Reddit
//   ttclid  = TikTok                  msclkid = Microsoft/Bing
const CLICK_ID_KEYS = ['oppref', 'gclid', 'fbclid', 'rdt_cid', 'ttclid', 'msclkid', 'click_id'];
// Audience country for display only (?cc=in). Two-letter, lowercased. Not attribution.
const COUNTRY_KEY = 'cc';

export default function MarketingRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const utm = {};
    for (const k of UTM_KEYS) {
      const v = (params.get(k) || '').toString().slice(0, 200).trim();
      if (v) utm[k] = v;
    }
    const clickIds = {};
    for (const k of CLICK_ID_KEYS) {
      const v = (params.get(k) || '').toString().slice(0, 400).trim();
      if (v) clickIds[k] = v;
    }

    const ccRaw = (params.get(COUNTRY_KEY) || '').toString().trim().toLowerCase();
    const country = /^[a-z]{2}$/.test(ccRaw) ? ccRaw : undefined;

    // Only capture if there's actually a source — otherwise this is just a bare hit.
    if (utm.utm_source) {
      const existing = localStorage.getItem('revfer_mktg'); // first-touch wins
      if (!existing) {
        const attribution = {
          ...utm,
          click_ids: Object.keys(clickIds).length ? clickIds : undefined,
          country,
          captured_at: new Date().toISOString(),
          expires_at: new Date(Date.now() + ATTRIBUTION_TTL_DAYS * 86400000).toISOString(),
        };
        try {
          localStorage.setItem('revfer_mktg', JSON.stringify(attribution));
        } catch (e) {
          console.warn('localStorage unavailable for marketing attribution', e);
        }
      }
    }

    // Land on the real sign-in page. Query string dropped on the redirect,
    // which is fine — we already captured what we needed.
    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 2 }}>
      <CircularProgress size={28} />
      <Typography variant="body2" color="text.secondary">Loading...</Typography>
    </Box>
  );
}